/**
 *  yii2-starter-kit @author Eugene Terentev <eugene@terentev.net>
 *
 *  tatva-sh
 */

import ChainContainer from "./ChainContainer";
import SelectionBox from "./SelectionBox";


// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {value: function (r) {
        if (null == this)
            throw new TypeError('"this" is null or not defined');
        var e = Object(this), t = e.length >>> 0;
        if ("function" != typeof r)
            throw new TypeError("predicate must be a function");
        for (var n = arguments[1], i = 0; i < t; ) {
            var o = e[i];
            if (r.call(n, o, i, e))
                return i;
            i++
        }
        return-1
    }, configurable: !0, writable: !0});

//used in react components, especially when dealing with info bar
globalFunctions.objectTypes = {"OBJECT": "OBJECT", "REFERENCE": "REFERENCE", "SOURCE": "SOURCE", "REFERENCE_NO":"REFERENCE_NO", "OPEN_POINT":"OPEN_POINT", "END_POINT":"END_POINT"};

function addErrorMessage(fieldObject, message, key, specificClassSelector, add) {
    fieldObject.removeClass("error");
    var finder = ".ui.red.pointing.label." + specificClassSelector;
    fieldObject.find(finder).remove();
    if (add === 1) {
        fieldObject.addClass("error");
        fieldObject.append('<div data-i18n="' + key + '" class="ui red pointing label ' + specificClassSelector + '">' + message + '</div>');
        globalFunctions.applyTranslatedMessage(key, finder);
    }
}
var newSourceViewId = "";
$(document).ready(function () {

    // Fullscreen icon is only display in object details page
    // setTimeout(function() {
        if ($("#view-chain-object-detail-container").length > 0) { $(".full-screen-mode").css("display","block"); }
    // }, 1000);

    if($("#search-page").length > 0) {$(".wrap").css("background","#FFFFFF");}
    
    var cellPhoneNumberRegex = /^\+(?:[:[0-9] ?){6,14}[0-9]$/;

    $('.menu .item').tab(); //initialize tabs

    $('.ui.checkbox').checkbox();   //initialize checkbox(s)

    $('.ui.dropdown').dropdown();   //initialize dropdown(s)

    $('.ui.accordion').accordion(); //initialize accordion


    $("button#btn-start-verification").popup();

    $("input[id*=cell_phone_number]").popup();

    $("#search-date").calendar({
        type: 'date',
        firstDayOfWeek: 1
    });

    $('div#sidebar')    //code to display left sidebar
            .sidebar('setting', 'transition', 'overlay')
            .sidebar('setting', 'mobileTransition', 'overlay')
            .sidebar('attach events', 'button.toggle-sidebar', 'show');

    var dataTableOptions = {"order": [], //order has to be set seperately
        "responsive": true,
        "autoWidth": false,
        "searching": true,
        "fnDrawCallback": function (oSettings) {
            //this code is used to hide and show pagination
            $("#my-objects").removeClass("hide");
            //jQuery('#search-result table').removeClass("hide");
            $("#favorite-object-listings table").removeClass("hide");
            if (oSettings._iDisplayLength >= oSettings.fnRecordsDisplay()) {
                $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
            } else {
                $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
            }
        }
    };

    var language = $("input[name=change-language]").val();

    if(language){
       //do something
    }else{
       language = 'en';
    }

    if ((language == "es") || (language == "sv")) {
        dataTableOptions["language"] = {"url": site_url + '/i18n/' + "dataTables." + language + ".json"};
    }

    dataTableOptions["searching"] = false;
    var search_table = $("#search-result>table").DataTable(dataTableOptions);
    dataTableOptions["searching"] = true;

    dataTableOptions["order"] = [[3, "desc"]];
    $('#my-objects').DataTable(dataTableOptions);
    dataTableOptions["order"] = [];

    $("#favorite-object-listings table").DataTable(dataTableOptions);

    //using shortcut to navigate to a chain
    $("body #shortcut-links").on("click", "a", function (e) {
        e.preventDefault();
        var id = $(this).attr("href").substring(1);
        var element = document.getElementById(id);
        scrollReferencePointIntoView(element, id);
    });
    $("body").on("change", "#objmovie-type", function (e) {
        e.preventDefault();
        var value = $('#objmovie-type input').val();
        if(value != 5){
            $(".field-movie-url").addClass("hidden");
            $("#movie-url").addClass("hidden");
            $("#movie-url").val("");
        }else{
            $(".field-movie-url").removeClass("hidden");
            $("#movie-url").removeClass("hidden");
        }
    });

    $("body").on("change", "#objarticle-type", function (e) {
        e.preventDefault();
        var value = $('#objarticle-type input').val();
        setTimeout(() => {
        if($('#objarticle-type').find(".transition").find('.selected').html()){
            var nameTemp =  $('#objarticle-type').find(".transition").find('.selected').html();
            name = nameTemp.toLowerCase();
        }else if($('#objarticle-type').find('.selected').html()){
            var nameTemp =  $('#objarticle-type').find('.selected').html();
            name = nameTemp.toLowerCase();
        }

        $("#news_type").html("Name of "+name);
        }, 500);
        if(value == 2){
            $(".field-object-news-paper-name").addClass("hidden");
            $("#object-news-paper-name").addClass("hidden");
            $("#object-news-paper-name").val("");
            $(".field-objarticle-published_on_paper").addClass("hidden");
            $("#objarticle-published_on_paper").addClass("hidden");
            $(".field-article-page-number").addClass("hidden");
            $(".field-end_article-page-number").addClass("hidden");

        }else{
            $(".field-object-news-paper-name").removeClass("hidden");
            $("#object-news-paper-name").removeClass("hidden");
            $(".field-objarticle-published_on_paper").removeClass("hidden");
            $("#objarticle-published_on_paper").removeClass("hidden");
            $(".field-article-page-number").removeClass("hidden");
            $(".field-end_article-page-number").removeClass("hidden");

        }
    });

    //toggle search bar
    // $("button#search-button").on("click", function () {
    //     var searchBar = $("div#search-bar-container");
    //     if (searchBar.is(":hidden")) {
    //         searchBar.transition({animation: 'slide down',
    //             onStart: function () {
    //                 $(this).removeAttr("style");
    //                 $(this).css({display: 'block'});
    //             },
    //             onComplete: function () {
    //                 $(this).find("input[type=text]").focus();
    //                 $(this).removeAttr("style");
    //                 $(this).css({display: 'block'});
    //             }
    //         });
    //     } else {
    //         searchBar.transition({animation: 'slide down',
    //             onStart: function () {
    //                 $(this).removeAttr("style");
    //                 $(this).css({display: 'block'});
    //             }});
    //     }
    // });

    $("#search-bar-container input").on("keyup", function (e) {
        if (e.keyCode != 13) {
            return;
        }    //not pressed enter
        var searchKeyword = $(this).val();
        $.ajax({
            type: 'get',
            url: site_url + '/search',
            dataType: 'json',
            data: {keyword: searchKeyword},
            error: function (jqxhr, status, exception) {
                //console.log(exception);
                //console.log(status);
                //console.log(jqxhr);
            }
        });

    });

    //close search bar when clicked on cross button
    $("#close-search-bar").on("click", function () {
        var searchBar = $("div#search-bar-container");
        searchBar.transition({animation: 'slide down',
            onStart: function () {
                $(this).removeAttr("style");
                $(this).css({display: 'block'});
            }});
    });

    $(".ui.buttons.dropdown-container").on("click", function (e) {
        //e.stopPropagation();
    });
    $("div.context-dropdown-container").bind("contextmenu", function (event) {
        // Avoid the real one
        event.preventDefault();
        // Show contextmenu
        $(this).find(".context-menu").finish().toggle(0, function () {
            $(this).css({height: "initial"});

            var windowHeight = $(window).height();
            var mousePointer = event.pageY;
            var heightOfMenu = $(this).height();
            var top = 0;

            if ((windowHeight - mousePointer) > heightOfMenu) {	//there's enough space below
                top = mousePointer;
                //console.log("there's enough space below");
            } else if (mousePointer > heightOfMenu) {	//there's enough space above
                top = mousePointer - heightOfMenu;
                //console.log("there's enough space above");
            } else {	//there's neither enough space above nor below, so we'll place the menu wherever there is more room available
                if ((windowHeight - mousePointer) > mousePointer) {	//there's more room available below
                    $(this).css({height: (windowHeight - mousePointer) + "px"});
                    top = mousePointer;
                    //console.log("there's more room available below");
                } else {	//there's more room available above
                    $(this).css({height: mousePointer + "px"});
                    top = 0;
                    //console.log("there's more room available above");
                }
            }
            // In the right position (the mouse)
            $(this).css({top: top + "px", left: event.pageX + "px"});
            //console.log("windowHeight = ", windowHeight, "mousePointer = ", mousePointer, "heightOfMenu = ", heightOfMenu);
        });
    });


    // If the document is clicked somewhere
    $(document).bind("mousedown", function (e) {
        // If the clicked element is not the menu
        if (!$(e.target).parents(".context-menu").length > 0) {
            // Hide it
            $(".context-menu").hide(0);
        }
    });


    // If the context menu element is clicked DUMMMMMMYYYYYYY
    $(".context-menu li").click(function () {
        switch ($(this).attr("data-action")) {
            case "first":
                alert("first");
                break;
            case "second":
                alert("second");
                break;
            case "third":
                alert("third");
                break;
        }
        $(".context-menu").hide();
    });



    //changeLanguageNavbar
    $("#changeLanguageNavbar, input[name=change-language]").on("change", function (e) {
        $(e.target).parents("form").submit();

    });

    //changeMenu
    // $("input[name=change-menu]").on("change", function (e) {
    //     var val = $(e.target).val();
    //     window.location = val;
    //     document.cookie = "_menu="+val+";path=/";

    // });

    $("body").on("click", "button#btn-start-verification", function (e) {
        //validate number
        var cellNumber = $("#userprofile-cell_phone_number")[0];
        //console.log("cellNumber.value = ", cellNumber.value);
        if ((cellNumber.value.length === 0)) {    //empty
            return;
        } else if (!(cellPhoneNumberRegex.test(cellNumber.value))) {    //regex
            return;
        }
        //if successfully validated
        //send cell number to server using ajax
        $(e.target).addClass("loading disabled");
        var data = {'cell_number': cellNumber.value};
        $.ajax({
            type: 'post',
            url: site_url + '/user/default/verify-number',
            dataType: 'json',
            data: data,
            success: function (response) {
                if (response.success) {
                    response.result = JSON.parse(response.result);
                    var messageId = response.result.messageId;
                    setTimeout(function () {
                        checkSMSStatus(e.target, messageId);
                    }, 4000);
                } else {
                    customSMSMessage(e.target, response.message);
                }
            },
            error: function (jqxhr, status, exception) {
                //console.log(exception);
                //console.log(status);
                //console.log(jqxhr);
            }
        });
    });

    $("body").on("click", "button#confirm-otp", function (e) {
        var otp = $("#otp_value").val();
        if (otp.length === 0) {
            return;
        }
        $(e.target).addClass("loading disabled");
        var data = {'otp': otp};
        $.ajax({
            type: 'post',
            url: site_url + '/user/default/verify-otp',
            dataType: 'json',
            data: data,
            success: function (response) {
                if (response.success) {
                    customOTPMessage(e.target, response.message, 1);
                    reloadPage(2000);
                } else {
                    customOTPMessage(e.target, response.message, 0);
                }
            },
            error: function (jqxhr, status, exception) {
                //console.log(exception);
                //console.log(status);
                //console.log(jqxhr);
            }
        });
    });


    //handle select type of new chain or source
    $("body").on("click", "#object-form > #select-type", function (e) {
        var parentId = $(this).siblings("input[name=belongsTo]").val();
        var viewId = $(this).siblings("input[name=viewId]").val();
        var rootId = $(this).siblings("input[name=rootId]").val();
        var type = 0, labelType = '';
        var  isProtected =  document.getElementById("is_protected").checked;
        if(isProtected){
            isProtected = 'yes';
        }else{
            isProtected = 'no';
        }
        $().changeButtonStateToLoading("#select-type");
        $(this).siblings(".field").each(function () { //find out the selected type
            var t = $(this).find("input")[0];
            if (t.checked) {
                type = t.value;
                labelType = $(this).find("label").text().trim();
                return false;   //break the loop
            }
        });
        createFormForAddingObjects(parentId, rootId, viewId, type, labelType, isProtected);
    });

    //handles edit object and source
    $("body").on('click', "#object-form > button#edit-object", function (e) {
        var isValid = validate("#object-form");
        if (!isValid) {
            return;
        }
        $().changeButtonStateToLoading("#edit-object");
        var data = new FormData($("#object-form")[0]);
        $.ajax({
            type: 'post',
            url: site_url + "/chain/edit_object",
            dataType: 'json',
            data: data,
            processData: false,
            contentType: false,
            success: function (response) {
                if (response.success) {
                    appendMessageToObjectForm(0, response.message);
                    $().closeFormSidebar();
                    loadChain(10, true);
                } else {
                    var errorList = response.message
                            .split("<br>")
                            .map((error) => ("<li>" + error + "</li>")).join('');
                    appendMessageToObjectForm(1, errorList);
                }
                $().changeButtonStateToNormal("#edit-object");
            },
            error: function (jqxhr, status, exception) {
                //console.log((site_url + '/chain/add_chain'), "error");
                //console.log(exception);
                //console.log(status);
                //console.log(jqxhr);
            }
        });
    });

    //handles opening of upload modal form for books and articles
    $("body").on("click", "#object-form [name*=uploadedFile][type=file]", function (e) {
        e.preventDefault();
        var sourceId = $(this).parents("#object-form").find("[name=sourceId]").val();

         var openUploadForm = globalFunctions.openUploadForm[sourceId];
         // console.log("openUploadForm = ", globalFunctions.openUploadForm[sourceId]);
         if (typeof openUploadForm === "undefined") {
         return;
         }
         globalFunctions.onModalClose = () => {
         $("#object-form-container").sidebar("toggle");
         };
         openUploadForm(true);
         $("#object-form-container").sidebar("toggle");
    });

    //handles add chain and source
    
    $("body").on('click', "#object-form #add-object,#add-source-to-po", function (e) {
        var isValid = validate("#object-form");
        if (isValid) {
            var data = new FormData($(this).parents("form")[0]);
            $().changeButtonStateToLoading("#" + e.target.id);
            var onResolved = (response) => {
                if (response.success) {
                    appendMessageToObjectForm(0, response.message);
                    $().closeFormSidebar();
                    loadChain();
                    newSourceViewId = response.viewId;
                    //reloadPage(1000);
                } else {
                    var errorList = response.message
                            .split("<br>")
                            .map((error) => ("<li>" + error + "</li>")).join('');
                    $().changeButtonStateToNormal("#" + e.target.id);
                    appendMessageToObjectForm(1, errorList);
                }
            };

            var onRejected = (error) => {
                //console.log("add object failed");
                $().changeButtonStateToNormal("#" + e.target.id);
            };

            addObject(data).then((response) => onResolved(response),
                    (error) => onRejected(error));
        }
    });

    //handles start object, opens up modal
    $("#create-object-form-container form#form-container div#select-type-create-object").css({"display": "block"});
    $("#save-select-type-container button#save-selection").hide();
    $("#save-select-type-container-stylize-form button#send-create-form").hide();

    // $("button.start-object.button").on("click", function (e) {
    //     $(".ui.modal#create-object-form-container form#form-container div#select-type-create-object").css({"display": "block"});
    //     $(".ui.modal#create-object-form-container form#form-container div#stylize-form").css({"display": "none"});
    //     $(".ui.modal#create-object-form-container form#form-container div#stylize-form").html("");
    //     $(".ui.modal#create-object-form-container form#form-container div.error-summary ul").html("");
    //     $("#save-select-type-container button#send-create-form").hide();
    //     $("#save-select-type-container button#save-selection").show();
    //     $("#save-select-type-container button#save-selection").hide();
    //     $(".ui.modal#create-object-form-container form#form-container").removeClass("error");
    //     $(".ui.modal#create-object-form-container").modal({closable: false,
    //         centered: false,
    //         onShow: function () {
    //             $(".ui.modal#create-object-form-container").removeClass('tiny');
    //         }})
    //             .modal("show");
    // });

    //opens object form
    $("body").on("click",".object-button", function(e){
       $("#object-hidden-input").val($(this).data('value'));
       $("#object-text-name").html($(this).text()).hide();
       $("#save-select-type-container button#save-selection").trigger( "click" );
       $(".ui.modal#create-object-form-container-stylize-form").modal({closable: false,
            centered: false,
            onShow: function () {
                $(".ui.modal#create-object-form-container-stylize-form").removeClass('tiny');
            }})
                .modal("show");
       e.preventDefault();
    });

    //submits form of create object
    $("body").on("click", "#save-select-type-container-stylize-form button#send-create-form", function (e) {
        $("#send-create-form").attr("disabled", true);
        var isValid = validate("#form-container-stylize-form");
        if (isValid) {
            $().changeButtonStateToLoading("#send-create-form");
            var data = new FormData($("#form-container-stylize-form")[0]);
            //data.delete('select-object-type');
            var onResolved = (response) => {
                if (response.success == 1) {
                    $(this).parent().siblings("form").removeClass("error");
                    $(this).parent().siblings("form").find(".error-summary").remove();
                    $(this).parent().siblings("form").append('<div class="ui positive message">' +
                            response.message +
                            '</div>');
                    $("#send-create-form").attr("disabled", false);
                    setTimeout(function () {
                        window.location.assign(site_url + "/" + response.id);
                    }, 500);
                } else {
                    $(this).parent().siblings("form").addClass("error");
                    $(this).parent().siblings("form").find(".error-summary > ul > li").remove();
                    response.error.split("<br>").map((error) =>
                        $(this).parent().siblings("form")
                                .find(".error-summary > ul").append("<li>" + error + "</li>"));
                    $().changeButtonStateToNormal("#send-create-form");
                }
            };

            var onRejected = (error) => {
                //console.log("add object failed");
                $().changeButtonStateToNormal("#send-create-form");
            };

            //$(this).addClass("disabled");

            addObject(data, '/chain/create_object').then((response) => onResolved(response), (error) => onRejected(error));
        } else {
            $("#send-create-form").attr("disabled", false);
        }
    });

    $("#save-select-type-container button#save-selection").on("click", function (e) {
        var type = $(this).parent().siblings("#select-type-create-object").find("[name=select-object-type]").first().val();
        var selectedText = $("#object-text-name").text();

        $(this).parent().siblings("#form-container-stylize-form").addClass("loading");
        // $("#create-object-form-container form#form-container div#select-type-create-object").css({"display": "none"});
        // $(".ui.modal#create-object-form-container-stylize-form form#form-container div#stylize-form").css({"display": "none"});
        $('#create-object-form-container-stylize-form').show();
        var onResolved = (response) => {
            // console.log(response);
            $("#form-container-stylize-form").removeClass("loading");
            $("#form-container-stylize-form")
                    .find("#stylize-form")
                    .html(response
                            + '<input type="hidden" name="object_type" value="' + type + '">');
            $("#create-object-form-container-stylize-form").children(".header").text(selectedText);
            $().initializeFormControls();
            $("body").addClass("scrolling");
            $(this).hide();
            $("#save-select-type-container-stylize-form button#send-create-form").show();
            $(".ui.modal#create-object-form-container-stylize-form").addClass("tiny");
            $().changeButtonStateToNormal("#send-create-form");
            if($('#dropdown-movie-type').length > 0){
                $('#dropdown-movie-type').dropdown('set selected', "");
            }
            if($('#objevent-type').length > 0){
                $('#objevent-type').dropdown('set selected', "");
            }
        };

        var onRejected = (error) => {
            //console.log("Error occurred while fetching form for create object");
        };

        fetchCreateForm(type, 1).then((response) => onResolved(response), (error) => onRejected(error));
    });

    $("body").on("click", "#add-chain", function (e) {
        var isValid = false
        // if($('input[name=referenceType]').val() == 12) {
        //     isValid = true
        // } else {
        //     isValid = validate("#object-form");
        // }

        isValid = validate("#object-form");

        if (isValid) {
            var data = new FormData($(this).parents("form")[0]);
            var directSource = $(this).siblings("[name=directSource]");
            if (directSource.length === 1) {
                $().beforeFetchFormSidebar();
            }
            $().changeButtonStateToLoading("#add-chain");
            $.ajax({
                type: 'post',
                url: site_url + "/chain/add_chain",
                dataType: 'json',
                data: data,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (directSource.length === 1) {
                        $().afterFetchFormSidebar();
                    }
                    if (response.success) {
                        if (typeof response.form !== "undefined") {
                            $("#title-form-object").html("Add source");
                            $("#sub-title-form-object").html(response.sourceTypeLabel);
                            var viewId = response.reference.viewId + "-" + response.reference.total;
                            $("#object-form").html(response.form
                                    +
                                    '<input type="hidden" name="refId" value="' + response.refId + '">'
                                    +
                                    '<input type="hidden" name="viewId" value="' + viewId + '">'
                                    +
                                    '<input type="hidden" name="rootId" value="' + response.rootObjectId + '">'
                                    +
                                    '<input type="hidden" name="object_type" value="' + response.objectType + '">'
                                    +
                                    '<button type="button" id="add-source-to-po" class="ui button">Add</button>'
                                    );
                            $().initializeFormControls();
                        } else {
                            $().changeButtonStateToNormal("#add-chain");
                            appendMessageToObjectForm(0, response.message);
                            $().closeFormSidebar();
                        }
                        //reload chain and update links
                        loadChain();
                    } else {
                        var errorList = response.message
                                .split("<br>")
                                .map((error) => ("<li>" + error + "</li>")).join('');
                        $().changeButtonStateToNormal("#add-chain");
                        appendMessageToObjectForm(1, errorList);
                    }
                },
                error: function (jqxhr, status, exception) {
                    //console.log((site_url + '/chain/add_chain'), "error");
                    //console.log(exception);
                    //console.log(status);
                    //console.log(jqxhr);
                }
            });
        }
    });

    $("body").on("click", "i.close-message", function () {
        $(this).parent().remove();
    });

    $("#get-tiny-url").modal({
        onShow: function () {
            $("#copy-tiny-url-container>button").removeClass("disabled");
        }
    });

    $("body").on("click", "#my-objects .tiny-url", function () {
        displayTinyUrl($(this).attr("data-url"));
    });

    $("#copy-tiny-url-container>button").on("click", function () {
        var element = $("#get-tiny-url .content p")[0];
        if (document.body.createTextRange) {
            var range = document.body.createTextRange();
            range.moveToElementText(element);
            range.select();
        } else if (window.getSelection) {
            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        document.execCommand("copy");
        $("#copy-tiny-url-container>button").addClass("disabled");
    });

    //publish chain
    $("body").on("click", "#publish-object", function (e) {
        // show .modal
        if ($(this).hasClass("green")) { //published, want to unpublish
            performPublish($(this));
            return;
        }
        $("#publish-message.ui.modal")
                .modal({
                    onApprove: (e) => {
                        setTimeout(() => performPublish($(this)), 500);
                    },
                    onDeny: (e) => undefined,
                    closable: false
                })
                .modal("show");
        return;
    });

    $("#commence-search").on("click", function (e) {
        e.preventDefault();
        var formData = new FormData($(this).parents("form")[0]);
        $("#search-result").addClass("ui form loading");
        search_table.clear().draw();
        
        var searchText = $("#searchObject").val();

        if(searchText.length > 0){
            $.ajax({
                type: 'post',
                url: site_url + "/search",
                dataType: 'json',
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if(response.length){
                        jQuery('#search-result').show();
                        //search_table
                        var rows = response;
                        for (var key in rows) {
                            //console.log(rows[key].view_id, rows[key].name, rows[key].type, rows[key].total_sources, rows[key].vote_count);
                            var dataTableRow = search_table.row.add([
                                rows[key].view_id,
                                rows[key].name,
                                rows[key].type,
                                // rows[key].total_sources,
                                // rows[key].vote_count,
                                '<a href="' + site_url + '/' + rows[key].view_id + '">'
                                        + '<i class="icon eye"></i>'
                                        + '</a>'
                            ]).draw(false).node();
                            $(dataTableRow).addClass("text-center");
                        }
                    }
                    else{
                        jQuery('#search-result').hide();
                    }
                    $("#search-result").removeClass("ui form loading");
                },
                error: function (jqxhr, status, exception) {
                    //console.log((site_url + '/chain/add_object'), "error");
                    //console.log(exception);
                    //console.log(status);
                    //console.log(jqxhr);
                }
            });
        }else{
            jQuery('#search-result').hide();
            $("#search-result").removeClass("ui form loading");
        }
    });

    //select next object
    $("body").on("click", "#arrow-right", function () {
        if (typeof globalFunctions.toggleSelectedObject === "undefined") {
            return;
        }
        globalFunctions.toggleSelectedObject(true);
    });

    //select prev object
    $("body").on("click", "#arrow-left", function () {
        $('.object-detail').removeClass("editObject");
        if (typeof globalFunctions.toggleSelectedObject === "undefined") {
            return;
        }
        globalFunctions.toggleSelectedObject(false);
    });

    $("body").on("click", "#arrow-bottom", function () {
        var currentId = getCurrentSelectedReferencePoint();
        // console.log("currentId = ", currentId);
        if (currentId === false) {
            return;
        }
        var currentIndex = globalFunctions.referencePointIds.findIndex(function (referenceId) {
            return referenceId === currentId;
        });
        var nextIndex = currentIndex + 1;
        // console.log("globalFunctions.updateReferencePoint = ", Object.keys(globalFunctions.updateReferencePoint).length, globalFunctions.updateReferencePoint);
        if (typeof globalFunctions.lastSelectedChain === "undefined") {
            nextIndex = currentIndex;
            globalFunctions.lastSelectedChain = "";
        }
        globalFunctions.lastSelectedChain = globalFunctions.referencePointIds[nextIndex];
        var id = globalFunctions.lastSelectedChain;
        var element = document.getElementById(id);
        // console.log("nextIndex = ", nextIndex, globalFunctions.referencePointIds[nextIndex]);
        scrollReferencePointIntoView(element, id);
    });

    $("body").on("click", "#arrow-top", function () {
        var currentId = getCurrentSelectedReferencePoint();
        // console.log("currentId = ", currentId);
        if (currentId === false) {
            return;
        }
        var currentIndex = globalFunctions.referencePointIds.findIndex(function (referenceId) {
            return referenceId === currentId;
        });
        var prevIndex = currentIndex - 1;
        // console.log("globalFunctions.updateReferencePoint = ", Object.keys(globalFunctions.updateReferencePoint).length, globalFunctions.updateReferencePoint);
        if (typeof globalFunctions.lastSelectedChain === "undefined") {
            prevIndex = currentIndex;
            globalFunctions.lastSelectedChain = "";
        }
        globalFunctions.lastSelectedChain = globalFunctions.referencePointIds[prevIndex];
        var id = globalFunctions.lastSelectedChain;
        var element = document.getElementById(id);
        // console.log("prevIndex = ", prevIndex, globalFunctions.referencePointIds[prevIndex]);
        scrollReferencePointIntoView(element, id);
    });

    // below code handles green selection for snapshot

    var resizeHighlightSelector = ".main-wrapper #snapshot-modal #snapshot-highlight-image-portion";
    var isMouseDownResize = false;
    // var resizeHighlightContent = ".main-wrapper #snapshot-modal #snapshot-highlight-image-portion";
    var isMouseDownContent = false;
    var prevPositionMovingHighlight = -1;

    $("#show-object").on("mousedown", resizeHighlightSelector, function (e) {
        e.preventDefault();
        if (isMouseDownContent) {
            return;
        }
        // console.log("resize cursor = ", $(this).css("cursor"));
        isMouseDownResize = true;
    });

    $("#show-object").on("mousedown", resizeHighlightSelector + " #hightlight-content", function (e) {
        e.preventDefault();
        // console.log("move cursor = ", $(this).css("cursor"));
        isMouseDownContent = true;
    });

    $("#show-object").on("mouseup", resizeHighlightSelector, function (e) {
        isMouseDownContent = false;
        isMouseDownResize = false;
        // console.log("mouse up");
        prevPositionMovingHighlight = -1;
    });

    $("#show-object").on("mousemove", resizeHighlightSelector, function (e) {
        if (!isMouseDownContent) {
            return;
        }
        var parentsHeight = parseFloat($(this).parent().css("height"));
        var thisHeight = parseFloat($(this).css("height"));
        var offset = $(this).parent().offset();
        var topOffsetThis = $(this).offset().top;
        var relativeOffsetOfThis = topOffsetThis - offset.top; // manipulate this offset
        var diffMousePointerTopThis = e.pageY - topOffsetThis;
        // below code moves content
        if (prevPositionMovingHighlight === -1) {
            prevPositionMovingHighlight = diffMousePointerTopThis;
            return;
        }
        var nextTop = relativeOffsetOfThis + (relativeOffsetOfThis - (relativeOffsetOfThis - (diffMousePointerTopThis - prevPositionMovingHighlight)));
        if ((nextTop < 0) || ((nextTop + thisHeight) >= parentsHeight)) { // don't let the box get out of image
            return;
        }
        $(this).css({top: Math.round(nextTop) + "px"});
    });

    $("body").on("mousemove", function (e) {
        if($(resizeHighlightSelector).length){
            e.preventDefault();
        }
        // this is used for resizing highlight box
        if (!isMouseDownResize || isMouseDownContent) {
            return;
        }
        var parentsHeight = parseFloat($(resizeHighlightSelector).parent().css("height"));
        var topOffsetThis = $(resizeHighlightSelector).offset().top;
        var diffMousePointerTopThis = e.pageY - topOffsetThis;
        var top = parseFloat($(resizeHighlightSelector).css("top"));

        if ((top + diffMousePointerTopThis) >= parentsHeight) {
            // don't expand below image
            return;
        }
        $(resizeHighlightSelector).css("height", Math.round(diffMousePointerTopThis) + "px");
    });

    $("body").on("mouseup", function (e) {
        e.preventDefault();
        // this is used to handle the scenario where
        // a user starts dragging inside the images leaves the mouse outside the image
        if (isMouseDownContent) {
            isMouseDownContent = false;
            prevPositionMovingHighlight = -1;
        }
        if (isMouseDownResize) {
            // console.log("resize init")
            isMouseDownResize = false;
        }
    });

    //code to handle green selection for snapshot ends here

    $("body").on("click", "#store-snapshot", function (e) {
        var copyright = $("#copyright input").val();
        if (!/^[^!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,255}$/.test(copyright)) {
            var messageHtml = globalFunctions.getTranslatedMessage("source-copyright-invalid-msg",
                    "Copyright can only contain letters and numbers");
            $("#copyright-msg").addClass("error").text(messageHtml);
            return;
        }
        var dateTime = $("[name=snapshot-date-time]").val();
        var sourceId = $("[name=snapshot-belongs-to]").val();
        var snapshotPath = $("[name=snapshot-path]").val();
        let topHeight = $("[name=top-height]").val();
        // console.log(dateTime, sourceId, snapshotPath);
        // var url = $("[name=reload-url]").val();
        $("#store-snapshot").addClass("loading");
        $("#cancel-store-snapshot").addClass("disabled");
        globalFunctions.toggleChainModalCloseIcon(true);
        $.ajax({
            type: 'post',
            url: site_url + '/chain/save-snapshot',
            dataType: 'json',
            data: {objectId: sourceId, path: snapshotPath, copyright: copyright, dateTime: dateTime, topHeight: topHeight},
            success: function (response) {
                var className = response.success ? 'success' : 'error';
                $("#copyright-msg").addClass(className).text(response.message);
                if (response.success) {
                    setTimeout(() => {
                        globalFunctions.toggleChainModal(false);
                        globalFunctions.loadChain();
                    }, 100);
                } else {
                    $("#store-snapshot").removeClass("loading");
                    $("#cancel-store-snapshot").removeClass("disabled");
                }
                globalFunctions.toggleChainModalCloseIcon(false);
            },
            error: function (jqxhr, status, exception) {
                // console.log(exception, status, jqxhr);
                $("#store-snapshot").removeClass("loading");
                $("#cancel-store-snapshot").removeClass("disabled");
                globalFunctions.toggleChainModalCloseIcon(false);
            }
        });
    });

    $("body").on("click", "#cancel-store-snapshot", function (e) {
        globalFunctions.toggleChainModal(false);
    });
    // the below code prevents submitting form on clicking enter
    $("body").on("submit", "#object-form", function (e) {
        e.preventDefault();
    });

    // now since we have added drag functionality to chain, the below code helps in
    // deciding whether we should drag or select the reference point
    // -------------------STARTS-------------------

    globalFunctions.shouldWeDrag = false;
    globalFunctions.isDrag = false;
    globalFunctions.isMove = false;

    $("body").on("mousedown", ".simplebar-content", function (e) {
        globalFunctions.shouldWeDrag = true;
        // console.log("mousedown simplebarcontent");
    });

    $("body").on("mousemove", ".simplebar-content", function (e) {
        if (globalFunctions.shouldWeDrag && !globalFunctions.isMove) {
            globalFunctions.isMove = true;
            // console.log("making ismove true")
            return;
        }
        if (globalFunctions.shouldWeDrag && globalFunctions.isMove && !globalFunctions.isDrag) {
            globalFunctions.isDrag = true;
            // console.log("isdrag true mouseenter simplebarcontent");
        }
    });

    $("body").on("mouseup", ".simplebar-content", function (e) {
        globalFunctions.shouldWeDrag = false;
        globalFunctions.isMove = false;
        // console.log("mouseup simplebarcontent");
    });

    // -------------------ENDS-------------------
});

globalFunctions.addHighImageHighlight = function (jQueryObj) {
    var width = jQueryObj.css("width");
    var parent = jQueryObj.parent();
    var thisLeft = jQueryObj.offset().left;
    var parentLeft = parent.offset().left;
    $("#snapshot-highlight-image-portion").remove();
    jQueryObj.append('<div id="snapshot-highlight-image-portion" draggable="true">' +
            '<div id="hightlight-content" draggable="true"></div></div>');
    // $("#snapshot-highlight-image-portion").css({
    //     width: "100%",
    //     height: "100px",
    //     top: "100px",
    //     // left: thisLeft - parentLeft
    // });
    // console.log(jQueryObj.parent());
    ReactDOM.render(<SelectionBox />, document.getElementById('snapshot-highlight-image-portion'));
};

function scrollReferencePointIntoView(element, id, selectReference = true) {

    if (element) {
       //console.log('element', element, id);
        // console.log("in scrollReferencePointIntoView = ", id)
        $('html,body').animate({
            scrollTop: $(element).offset().top - $(window).height() / 2
        }, 500);
        if ((typeof globalFunctions.updateReferencePoint[id] !== "undefined") && selectReference) {
            // console.log("not updating reference point")
            globalFunctions.updateReferencePoint[id]();
        }
}
}

// scroll to source id if provided
function scrollSourceIntoView(sourceId) {
    if(!sourceId) { return; }
    var sorceElement = $(`#${sourceId}`);
    if (sorceElement) {
        sorceElement.trigger("click");
    }
    // var chain_source = sorceElement.closest(".chain-source");
    // var outer = chain_source.parents(".simplebar-content");
    //   var target = chain_source; //Lets assume one element has the class active, it is the one we want to center
    //   var containerWidth = outer.width();
    //   var targetWidth = target.outerWidth(true);
    //   var targetIndex = chain_source.index(); //Tells us what position this is in. Useful in calculations

    //   // console.log(this.props.data.viewId, this.state.currentView, targetWidth, containerWidth)
    //   var leftScreenOffset = (containerWidth - targetWidth) / 2;
    //   var leftSiblingOffset = targetWidth * targetIndex;

    //   var scrollValue = leftSiblingOffset - leftScreenOffset;
    //   console.log(scrollValue);
    //   outer.scrollLeft(Math.max(0, scrollValue)); // our target is now centered
      $('html,body').animate({
        scrollTop: sorceElement.offset().top - $(window).height() / 4
    }, 500);
}

globalFunctions.scrollReferencePointIntoView = (element, id, selectReference = true) => scrollReferencePointIntoView(element, id, selectReference);

function getCurrentSelectedReferencePoint() {
    var currentId = "";
    if (typeof globalFunctions.updateReferencePoint === "undefined") {
        return false;
    } else if ((typeof globalFunctions.referencePointIds === "undefined") ||
            (globalFunctions.referencePointIds.length != globalFunctions.updateReferencePoint.length)) {
        globalFunctions.referencePointIds = globalFunctions.sortReferencesForTopAndBottomArrow();
    }
    currentId = globalFunctions.referencePointIds[0];
    if (typeof globalFunctions.lastSelectedChain !== "undefined") {
        // console.log("globalFunctions.lastSelectedChain = ", globalFunctions.lastSelectedChain);
        currentId = globalFunctions.lastSelectedChain;
    }
    return currentId;
}

function displayTinyUrl(url,sourceType) {
    var tinyURL = getTinyUrl(url);
    if(sourceType != undefined && (sourceType == 6 || sourceType == 9 || sourceType == 10 || sourceType == 11)){
        $("#get-tiny-url .header").text("URL to this archive image"); 
        if(url.includes("mediaArchiveViewer.php")){
            tinyURL = tinyURL.replace("/mediaArchiveViewer.php", "");
        }
    }else{
        $("#get-tiny-url .header").text("Tiny URL");
    }
    $("#get-tiny-url .content p").text(tinyURL);
    $("#get-tiny-url").modal("closable", false).modal("centered", true).modal("show");
}

function getTinyUrl(url) {
    // return '<script type="text/javascript" src="' + site_url + '/public/getChain.js"></script>'
    //         + '<script type="text/javascript">'
    //         + 'window.onload = function(){'
    //         + 'toGenerateLinks("' + url + '", "' + site_url + '");'
    //         + '};'
    //         + '</script>';
    return url;
}

globalFunctions.getTinyUrl = (url) => getTinyUrl(url);
globalFunctions.displayTinyUrl = (url, sourceType) => displayTinyUrl(url,sourceType);

function performPublish(btnReference) {
    $(btnReference).addClass("disabled loading");
    var viewId = $("input[name=object-id]").val();
    $.ajax({
        type: 'post',
        url: site_url + "/chain/publish",
        dataType: 'json',
        data: {viewId: viewId},
        success: (response) => {
            if (response.success) {
                $(btnReference).text(response.newCaption);
                $(btnReference).removeClass("blue green");
                $(btnReference).addClass(response.newClass);
                loadChain();
            } else if (typeof response.publishError !== "undefined") {
                $("#publish-error.ui.modal").find(".content").text(response.message);
                $("#publish-error.ui.modal").modal({closable: false}).modal("show");
            } else {
                /*use view-chain-object-detail-message as id
                 * for any message that you append
                 * in #view-chain-object-detail-container*/
                var errorList = response.message
                        .split("<br>")
                        .map((error) => ("<li>" + error + "</li>")).join('');
                var messageHTML = '<div id="view-chain-object-detail-message" class="ui negative message">' +
                        '<i class="close icon close-message"></i>' +
                        errorList +
                        '</div>';
                $("#view-chain-object-detail-message").remove();
                $(messageHTML).insertBefore(".view-chain-object-detail");
            }
            $(btnReference).removeClass("disabled loading");
        },
        error: function (jqxhr, status, exception) {
            //console.log((site_url + '/chain/publish'), "error");
            //console.log(exception);
            //console.log(status);
            //console.log(jqxhr);
        }
    });
}

function appendMessageToObjectForm(isError, message) {
    var classType = (isError === 1) ? "error" : "success";
    $("#object-form #object-form-message-summary").remove();
    $("#object-form").append('<div class="ui message ' + classType + '" id="object-form-message-summary">' +
            message + '</div>');
    $("#object-form").addClass(classType);
}

function removeMessageFromObjectForm() {
    $("#object-form-message-summary").remove();
}
//function to validate a form elements
function validate(parentSelector) {
    var isValid = [true];
    var isOkay;
    var children = $(parentSelector).find('input[name=referenceType]').val();
    var referenceType = $('#object-form').find('#reference-type');
    $(parentSelector + " input,select,textarea").each(function () {
        if ($(this).attr("id")) {
            if($(parentSelector).find('input[name=object_type]').val() == 10) {
                if($(this).attr("id") == "object-news-paper-name"  && $(this).hasClass("hidden")){
                    isOkay == true;
                }
            } else if($(parentSelector).find('input[name=object_type]').val() == 2){
                isOkay = $('input:text[name="ObjBook[authorDetails][0][firstname]"]').trigger("blur").data("isValid");
                isOkay = $('input:text[name="ObjBook[authorDetails][0][lastname]"]').trigger("blur").data("isValid");
                isOkay = $("body " + parentSelector + " #" + $(this).attr("id")).trigger("blur").data("isValid");
            } else if($(parentSelector).find('input[name=object_type]').val() == 8){
                isOkay = $('input:text[name="ObjEssay[authorDetails][0][firstname]"]').trigger("blur").data("isValid");
                isOkay = $('input:text[name="ObjEssay[authorDetails][0][lastname]"]').trigger("blur").data("isValid");
                isOkay = $("body " + parentSelector + " #" + $(this).attr("id")).trigger("blur").data("isValid");
            } else if($(parentSelector).find('input[name=object_type]').val() == 9) {
                isOkay = $('input:text[name="ObjBlog[authorDetails][0][firstname]"]').trigger("blur").data("isValid");
                isOkay = $('input:text[name="ObjBlog[authorDetails][0][lastname]"]').trigger("blur").data("isValid");
                isOkay = $("body " + parentSelector + " #" + $(this).attr("id")).trigger("blur").data("isValid");
            } else if($(parentSelector).find('input[name=object_type]').val() == 1)  {
                isOkay = $('input:text[name="ObjArticle[authorDetails][0][firstname]"]').trigger("blur").data("isValid");
                isOkay = $('input:text[name="ObjArticle[authorDetails][0][lastname]"]').trigger("blur").data("isValid");
                isOkay = $("body " + parentSelector + " #" + $(this).attr("id")).trigger("blur").data("isValid");
            } else if($(parentSelector).find('input[name=object_type]').val() == 11)  {
                isOkay = $('input:text[name="ObjArticleWeb[authorDetails][0][firstname]"]').trigger("blur").data("isValid");
                isOkay = $('input:text[name="ObjArticleWeb[authorDetails][0][lastname]"]').trigger("blur").data("isValid");
                isOkay = $("body " + parentSelector + " #" + $(this).attr("id")).trigger("blur").data("isValid");
            } else if($(parentSelector).find('input[name=object_type]').val() == 3)  {
                isOkay = $("body " + parentSelector + " #" + $(this).attr("id")).trigger("blur").data("isValid");
            } else if(children == 12 || referenceType.length > 0) {
                if($(parentSelector).find('input[type=radio]:checked')){
                    var checkedFlag = $(parentSelector).find('input[type=radio]').is(':checked');
                    // if(checkedFlag == true) {
                        var checkedValue = $(parentSelector).find('input[type=radio]:checked')
                        checkedValue.each(function( index ) {
                            if(checkedFlag == true){
                                if(checkedValue[index].id == 'w0-Reference[type]' || checkedValue[index].id == 'w2-Reference[type]' ){ 
                                    if($("#education-reference-date-time").val() != ""){
                                        isOkay =  $("#education-reference-date-time").trigger("blur").data("isValid");
                                    }
                                    if($("#end-education-reference-date-time").val() != ""){
                                        isOkay = $("#end-education-reference-date-time").trigger("blur").data("isValid");
                                    }
                                } else if(checkedValue[index].id == 'w1-Reference[type]' || checkedValue[index].id == 'w3-Reference[type]') {
                                    isOkay = $("#education-page-number").trigger("blur").data("isValid");
                                    isOkay = $("#end_education-page-number").trigger("blur").data("isValid");
                                } 
                            }else{
                                isOkay = true;
                            }
                          });
                        
                } else {
                    isOkay = $("body " + parentSelector + " #" + $(this).attr("id")).trigger("blur").data("isValid");
                }
            }
            else {
                if($(this).attr("id") == "object-news-paper-name"  && $(this).hasClass("hidden")){
                    isOkay == true;
                }  else{
                    isOkay = $("body " + parentSelector + " #" + $(this).attr("id")).trigger("blur").data("isValid");
                }
            }

            if (typeof isOkay !== "undefined") { //undefined is returned when an event handler does not exist
                isValid.push(isOkay);
            }
        }
    });
    return isValid.reduce(function (previousValue, currentValue, index) {
        if (index === 0) {
            return currentValue;
        }
        return previousValue && currentValue;
    });
}

function createFormForAddingObjects(parentId, rootId, viewId, type, labelType, isProtected = false) {
    $('.object-detail').removeClass("editObject");
    var prevMsg = $("#title-form-object").html(); //store previous message
    $().beforeFetchFormSidebar();
    $("#title-form-object").html(prevMsg);
    /* if(labelType == 'Blog') {
        $("#sub-title-form-object").html((labelType === 'Article'? labelType: labelType));
    } else if(labelType != 'Website') {
        $("#sub-title-form-object").html("Type: " + (labelType === 'Article'? labelType: labelType));
    } */ 
    $("#sub-title-form-object").html((labelType === 'Article'? labelType: labelType));

    if(isProtected === "yes") {
        var isCreate = 1;
        var formData = new FormData();
        formData.append( 'refId', parentId );
        formData.append( 'rootId', rootId );
        formData.append( 'viewId', viewId );
        formData.append( 'object_type', type );
        formData.append( 'is_protected', isProtected );

        var onResolved = (response) => {
            if (response.success) {
                appendMessageToObjectForm(0, response.message);
                $().closeFormSidebar();
                loadChain();
                //reloadPage(1000);
            } else {
                var errorList = response.message
                        .split("<br>")
                        .map((error) => ("<li>" + error + "</li>")).join('');
                $().changeButtonStateToNormal("#" + e.target.id);
                appendMessageToObjectForm(1, errorList);
            }
        };

        var onRejected = (error) => {
            //console.log("add object failed");
            $().changeButtonStateToNormal("#" + e.target.id);
        };

        addObject(formData).then((response) => onResolved(response), (error) => onRejected(error));
    } else {
        var onResolved = (response) => {
            $("#object-form").html(response + '<button class="ui button" id="add-object" type="button">Add</button>');
            $("#object-form").prepend('<input type="hidden" name="refId" value="' + parentId + '">' +
                    '<input type="hidden" name="rootId" value="' + rootId + '">' +
                    '<input type="hidden" name="viewId" value="' + viewId + '">' +
                    '<input type="hidden" name="object_type" value="' + type + '">' +
                    '<input type="hidden" name="is_protected" value="' + isProtected + '">');
            //console.log("in fetch create form parentId = ", parentId, ",type = ", type);
            $("#objarticle-type").trigger("change");
            if($('#dropdown-movie-type').length > 0){
                $('#dropdown-movie-type').dropdown('set selected', "");
            }
            if($('#objevent-type').length > 0){
                $('#objevent-type').dropdown('set selected', "");
            }
            $().afterFetchFormSidebar();
        };

        var onRejected = (error) => {
            //console.log("rejected");
        };

        fetchCreateForm(type).then((response) => onResolved(response), (error) => onRejected(error));
    }
}

function addObject(data, url = '/chain/add_source') {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: 'post',
            url: site_url + url,
            dataType: 'json',
            data: data,
            processData: false,
            contentType: false,
            success: function (response) {
                resolve(response);
            },
            error: function (jqxhr, status, exception) {
                //console.log((site_url + '/chain/add_object'), "error");
                //console.log(exception);
                //console.log(status);
                //console.log(jqxhr);
                reject(true);
            }
        });
    });
}

function fetchCreateForm(type, isCreate = 0) {
    var data = {"type": type, "create": isCreate};
    return new Promise(function (resolve, reject) {
        jQuery.ajax({
            type: 'post',
            url: site_url + '/chain/fetch_create_form',
            dataType: 'text',
            data: data,
            success: function (response) {
                resolve(response);
            },
            error: function (jqxhr, status, exception) {
                //console.log((site_url + '/chain/fetch_create_form'), "error");
                //console.log(exception);
                //console.log(status);
                //console.log(jqxhr);
                reject(true);
            }
        });
    });
}

function manageLeftAndRightArrows(contentBox) {
    var _this = contentBox;
    var rightBtn = _this.find(".next_arrow");
    var leftBtn = _this.find(".prev_arrow");
    var scrollLeftFactor = 50;
    var totalWidth = _this.find(".left_col").outerWidth(true)
            + _this.find(".left_col .link-div").outerWidth(true)
            + _this.find(".left_col .time-div").outerWidth(true)
            + _this.find(".right_col").outerWidth(true);
    /* _this.find(".column").each(function () {
     totalWidth += $(this).outerWidth(true);
     }); */
    var scrollLeftPosition = _this.find(".simplebar-content").scrollLeft();
    if ((totalWidth - 15) <= $(window).innerWidth()) {
        // difference between totalWidth and innerWidth should be atleast 15 pixels
        // console.log("hide buttons ");
        leftBtn.hide();
        rightBtn.hide();
    } else {
        rightBtn.show();
        leftBtn.hide();
    }
    // this is used when we are scrolling chain from ChainSource
    // console.log("scrollLeftPosition = ", scrollLeftPosition, "totalWidth = ", totalWidth, $(document).innerWidth());

    if (scrollLeftPosition !== 0) {
        // console.log("show both buttons ");
        rightBtn.show();
        leftBtn.show();
    }
    rightBtn.filter(":not(.bound)").on('click', function () {
        leftBtn.show();
        var maxposition = _this.find('.simplebar-content').get(0).scrollWidth - _this.find('.simplebar-content').get(0).clientWidth;
        var scrollValue = 0;
        scrollLeftPosition = _this.find(".simplebar-content").scrollLeft();
        if (scrollLeftPosition === 0) {
            scrollLeftFactor += 50;
            scrollValue = scrollLeftFactor;
        } else {
            scrollValue = scrollLeftPosition + 300;
        }
        _this.find(".simplebar-content").scrollLeft(scrollValue);
        if (scrollValue >= maxposition) {
            $(this).hide();
        }
    });
    leftBtn.filter(":not(.bound)").on('click', function () {
        rightBtn.show();
        var scrollValue = 0;
        scrollLeftPosition = _this.find(".simplebar-content").scrollLeft();
        if (scrollLeftPosition === 0) {
            scrollLeftFactor -= 50;
            scrollValue = scrollLeftFactor;
        } else {
            scrollValue = scrollLeftPosition - 300;
        }
        _this.find(".simplebar-content").scrollLeft(scrollValue);
        if (scrollValue <= 0) {
            $(this).hide();
        }
    });
    // the below code ensures that events are bound to left and right arrows only once
    // as this method is called multiple times
    if (!rightBtn.hasClass("bound")) {
        rightBtn.addClass("bound");
    }
    if (!leftBtn.hasClass("bound")) {
        leftBtn.addClass("bound");
    }
}

globalFunctions.manageLeftAndRightArrows = (contentBox) => manageLeftAndRightArrows(contentBox);

function disableTopAndBottomArrows(top, bottom) {
    if (top) { // disable top arrow
        $("#arrow-top").addClass("disabled");
        $("#arrow-top i").addClass("disabled");
    } else { // enable top arrow
        $("#arrow-top").removeClass("disabled");
        $("#arrow-top i").removeClass("disabled");
    }

    if (bottom) { // disable bottom arrow
        $("#arrow-bottom").addClass("disabled");
        $("#arrow-bottom i").addClass("disabled");
    } else { // enable bottom arrow
        $("#arrow-bottom").removeClass("disabled");
        $("#arrow-bottom i").removeClass("disabled");
    }
}

function disableLeftAndRightArrows(left, right) {
    if (left) { // disable left arrow
        $("#arrow-left").addClass("disabled");
        $("#arrow-left i").addClass("disabled");
    } else { // enable left arrow
        $("#arrow-left").removeClass("disabled");
        $("#arrow-left i").removeClass("disabled");
    }

    if (right) { // disable right arrow
        $("#arrow-right").addClass("disabled");
        $("#arrow-right i").addClass("disabled");
    } else { // enable right arrow
        $("#arrow-right").removeClass("disabled");
        $("#arrow-right i").removeClass("disabled");
    }
}

globalFunctions.disableTopAndBottomArrows = (top, bottom) => disableTopAndBottomArrows(top, bottom);
globalFunctions.disableLeftAndRightArrows = (left, right) => disableLeftAndRightArrows(left, right);

$.fn.extend({
    equalHeights: function () {
        var contentBox = $(this).parents(".content_box");
        setTimeout(() => {
            manageLeftAndRightArrows(contentBox);
        }, 10);
        return; // below code not required as the height of each chain is quite large to accommodate the expanded chain
        var greaterHeight = -1;
        $(this).each(function () {
            $(this).height('auto');
            var currentHeight = $(this).outerHeight();
            if (greaterHeight < currentHeight) {
                greaterHeight = currentHeight;
            }
        });
        $(this).each(function (index) {
            $(this).height(greaterHeight + 45);
        });
        setTimeout(() => {
            manageLeftAndRightArrows(contentBox);
        }, 10);
    },
    beforeFetchFormSidebar: function () {
        $("#object-form-container > #object-form").addClass("loading");
        $("#object-form-container").children().html("");
        $("#object-form").removeClass("success error");
    },
    afterFetchFormSidebar: function () {
        $().initializeFormControls();
        $("#object-form-container > #object-form").removeClass("loading");
    },
    initializeFormControls: function () {
        $("#is-voteable").popup();
        $(".ui.dropdown").dropdown();
        $(".ui.checkbox#are-your-views").checkbox({
            onChecked: function () {
                $(".opinion-holders-name").hide();
                $(this).val(1);
            },
            onUnchecked: function () {
                $(".opinion-holders-name input").val(""); //empty the value before showing
                $(".opinion-holders-name").show();
                $(this).val(0);
            }
        });
        $(".ui.checkbox#is-author, .ui.checkbox#is-voteable").checkbox({
            onChecked: function () {
                $(this).val(1);
            },
            onUnchecked: function () {
                $(this).val(0);
            }
        });

        $("#book-published-year-container").calendar({
            type: 'year'
        });

        $("#event-movie-year-container").calendar({
            type: 'year'
        });
        $("#publish-date-time-container").calendar({
            type: 'date',
            firstDayOfWeek: 1,
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD");
                        }
                    }
                    $(this).initializeGraph.date_format = date_format;
                }
            }
        });
        $("#blog-ref-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            onChange(date, text, mode){
                window.eventStartDate = date;
                $("#end-blog-date-time-container").calendar({
                    minDate: date
                });
            },
        });
        $("#blog-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            onChange(date, text, mode){
                window.eventStartDate = date;
                $("#end-blog-date-time-container").calendar({
                    minDate: date,
                    formatter: {
                        datetime: function(date, settings){
                            var date_format = $('input[name=date_format]').val();
                            if(typeof date === "undefined" || date == null){
                                return null;
                            }else{
                                if(date_format == 0){
                                    return moment(date).format("MM-DD-YYYY HH:mm:ss");
                                }else if(date_format == 1){
                                    return moment(date).format("YYYY-MM-DD HH:mm:ss");
                                }
                            }
                        }
                    }
                });
            },
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#end-blog-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#social-media-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            onChange(date, text, mode){
                window.eventStartDate = date;
                $("#end-social-media-date-time-container").calendar({
                    minDate: date,
                    formatter: {
                        datetime: function(date, settings){
                            var date_format = $('input[name=date_format]').val();
                            if(typeof date === "undefined" || date == null){
                                return null;
                            }else{
                                if(date_format == 0){
                                    return moment(date).format("MM-DD-YYYY HH:mm:ss");
                                }else if(date_format == 1){
                                    return moment(date).format("YYYY-MM-DD HH:mm:ss");
                                }
                            }
                        }
                    }
                });
            },
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#end-social-media-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#event-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            onChange(date, text, mode){
                window.eventStartDate = date;
                $("#end-event-date-time-container").calendar({
                    minDate: date,
                    formatter: {
                        datetime: function(date, settings){
                            var date_format = $('input[name=date_format]').val();
                            if(typeof date === "undefined" || date == null){
                                return null;
                            }else{
                                if(date_format == 0){
                                    return moment(date).format("MM-DD-YYYY HH:mm:ss");
                                }else if(date_format == 1){
                                    return moment(date).format("YYYY-MM-DD HH:mm:ss");
                                }
                            }
                        }
                    }
                });
            },
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        
        $("#end-event-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#event-from-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            onChange(date, text, mode){
                window.eventStartDate = date;
                $("#event-end-date-time-container").calendar({
                    minDate: date,
                    formatter: {
                        datetime: function(date, settings){
                            var date_format = $('input[name=date_format]').val();
                            if(typeof date === "undefined" || date == null){
                                return null;
                            }else{
                                if(date_format == 0){
                                    return moment(date).format("MM-DD-YYYY HH:mm:ss");
                                }else if(date_format == 1){
                                    return moment(date).format("YYYY-MM-DD HH:mm:ss");
                                }
                            }
                        }
                    }
                });
            },
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#event-end-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#education-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            onChange(date, text, mode){
                window.eventStartDate = date;
                $("#end-education-date-time-container").calendar({
                    minDate: date,
                    formatter: {
                        datetime: function(date, settings){
                            var date_format = $('input[name=date_format]').val();
                            if(typeof date === "undefined" || date == null){
                                return null;
                            }else{
                                if(date_format == 0){
                                    return moment(date).format("MM-DD-YYYY HH:mm:ss");
                                }else if(date_format == 1){
                                    return moment(date).format("YYYY-MM-DD HH:mm:ss");
                                }
                            }
                        }
                    }
                });
            },
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#end-education-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#education-experiment-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            onChange(date, text, mode){
                window.eventStartDate = date;
                $("#end-education-experiment-date-time-container").calendar({
                    minDate: date
                });
            },
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#ref-education-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            onChange(date, text, mode){
                window.eventStartDate = date;
                $("#ref-end-education-date-time-container").calendar({
                    minDate: date,
                    formatter: {
                        datetime: function(date, settings){
                            var date_format = $('input[name=date_format]').val();
                            if(typeof date === "undefined" || date == null){
                                return null;
                            }else{
                                if(date_format == 0){
                                    return moment(date).format("MM-DD-YYYY HH:mm:ss");
                                }else if(date_format == 1){
                                    return moment(date).format("YYYY-MM-DD HH:mm:ss");
                                }
                            }
                        }
                    }
                });
            },
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
        $("#ref-end-education-date-time-container").calendar({
            type: 'datetime',
            firstDayOfWeek: 1,
            formatter: {
                datetime: function(date, settings){
                    var date_format = $('input[name=date_format]').val();
                    if(typeof date === "undefined" || date == null){
                        return null;
                    }else{
                        if(date_format == 0){
                            return moment(date).format("MM-DD-YYYY HH:mm:ss");
                        }else if(date_format == 1){
                            return moment(date).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                }
            }
        });
    },
    initializeGraph: function (selector, referencePointLength, actualObjectData, objectData, referencePoints, typeId, title, isOwner = false) {
        
        $(selector + " .ui.dropdown").dropdown();
        $('.ui.sortable.table').tablesort();
        if (isOwner) {
            $('div#object-form-container')    //code to display right sidebar
                    .sidebar('setting', 'transition', 'overlay')
                    .sidebar('setting', 'mobileTransition', 'overlay')
                    .sidebar('attach events','li.display-edit-object-form,button.create-chain,button.add-source,div.tooltiptext > div.add-source','show')
                    .sidebar('attach events',
                            'body #infobar > #selected-object-id_Edit,li.display-edit-object-form,button.create-chain,button.add-source,div.tooltiptext > div.add-source',
                            'show');
        }
        if (referencePointLength >= 1) {
            $("#vertical-navigation-arrows").addClass("show");
            // i've used flex to remove whitspace node error in UI
        } else {
            $("#vertical-navigation-arrows").addClass("hide");
        }
        $("#title-view-chain > h1").text(title);
        var actualObject = $("#view-chain-object-detail-container #about-object");
        var object = $("#view-chain-object-detail-container #object-data");
        
        actualObject.find('.key-value-pair').remove();
        object.find('.key-value-pair').remove();
        for (var key in actualObjectData) {
            actualObject.append('<div class="key-value-pair">' +
                    '<span class="key">' + key + ' </span>' +
                    '<span class="value">' + actualObjectData[key] + '</span>' +
                    '</div>');
        }
        for (var key in objectData) {
            if(key == 'Updated At'){
                objectData[key] = moment(objectData[key]).fromNow(true)+' ago'; 
            }
            if(key == 'Created At'){
                continue;
            }
            if(key == 'Published'){
                if(actualObjectData.is_published){
                    var date_format = $('input[name=date_format]').val();
                    if(date_format == 0){
                        objectData[key] = moment(objectData[key]).format("MM-DD-YYYY HH:mm:ss")
                    }else if(date_format == 1){
                        objectData[key] = moment(objectData[key]).format("YYYY-MM-DD HH:mm:ss")
                    }   
                }
                else {
                    objectData[key] = '-'; 
                }
            }

            // object.append('<div class="key-value-pair ui row grid">' +
            //         '<span class="key six wide column">' + (key == 'Updated At' ? 'Updated': key ) + ' </span>' +
            //         '<span class="value ten wide column">' + objectData[key] + ((key == 'Object ID') ? '<span id="selected-object-info" style="margin-left:10px;cursor:pointer;"><i class="share square icon"></i> Share</span>' : '') +'</span>' +
            //         '</div>');
            object.append('<div class="key-value-pair ui row grid"' +(key == 'Created by' ? 'style="margin-bottom: 48px;"': '' ) +'>' +
                    '<span class="key six wide column">' + (key == 'Updated At' ? 'Updated': key ) + ' </span>' +
                    '<span class="value ten wide column">' + objectData[key]  +'</span>' +
                    '</div>');
        }
        $( "#selected-object-info" ).click(function() {
            globalFunctions.displayTinyUrl(site_url + '/' + objectData['Object ID']);
        });

        if(referencePoints != ""){
            $("#shortcut-links").html("");
        
            var refPoints = referencePoints.slice();
            var comparatorFunction = globalFunctions.getComparatorFunction(typeId);
            if (comparatorFunction !== null) {
                refPoints.sort(comparatorFunction);
            }
            refPoints.map((refPoint) => {
                $("#shortcut-links").append('<div class="item-wrap"><div class="key"><span><a style="font-weight: normal;" href="#' + refPoint.viewId + '">'
                        + (typeof refPoint.title !== "undefined" && refPoint.value !== null
                                ?
                                " " + (refPoint.title == 'Time' || refPoint.title== " " || refPoint.title== "Date Time"   ? refPoint.value.substring(0,refPoint.value.length - 3) : refPoint.title+' '+refPoint.value) + '</a></span></div> <div class="value" style="color:black;text-align: right;margin-bottom:6px;">(' + refPoint.viewId.substring(refPoint.viewId.indexOf("-") + 1) + ")</div><div class='dotted' style='border-bottom: 1px dotted grey;margin-bottom:2px;'></div></div>"
                                :
                                ""
                                ));
            });
        }
    },
    closeFormSidebar: function () {
        $('div#object-form-container').animate({scrollTop: $('div#object-form-container').height()});
        setTimeout(function () {
            $('div#object-form-container').sidebar('hide');
        }, 600);
    },
    changeButtonStateToLoading: function (selector) {
        $(selector).addClass("loading disabled");
    },
    changeButtonStateToNormal: function (selector) {
        $(selector).removeClass("loading disabled");
    }
});

function checkSMSStatus(target, messageId) {
    var data = {'messageId': messageId};
    $.ajax({
        type: 'post',
        url: site_url + '/user/default/sms-status',
        dataType: 'json',
        data: data,
        success: function (response) {
            if (response.success) {//response successfull
                //display OTP field
                var otpField = '<div class="eight wide column" id="otp_value_container">' +
                        '<input id="otp_value" type="text" placeholder="Enter OTP">' +
                        '</div>' +
                        '<div class="six wide column">' +
                        '<button type="button" id="confirm-otp" class="ui button primary">' +
                        response.buttonCaption +
                        '</button>' +
                        '</div>';
                $(target).parents(".user-cell-phone-number-container").append(otpField);
                $(target).remove(); //remove the button
            } else {
                customSMSMessage(target, response.message);
            }
        },
        error: function (jqxhr, status, exception) {
            //console.log(exception);
            //console.log(status);
            //console.log(jqxhr);
        }
    });
}

function customSMSMessage(target, message) {
    var siblings = $(target).parent().siblings("#get-cell-number");
    siblings.find("input")
            .after('<div id="custom-error" class="ui red pointing label" style="display: block;">'
                    + '</div>');
    setTimeout(function () {
        siblings.find("#custom-error").text(message);
    }, 10);

    setTimeout(function () {
        siblings.find("#custom-error").fadeOut(function () {
            siblings.find("#custom-error").remove();
        });
        $(target).removeClass("loading disabled");
    }, 1500);
}

function customOTPMessage(target, message, flag = 0) {
    var siblings = $(target).parent().siblings("#otp_value_container");
    siblings.find("#custom-error").remove();
    siblings.find("input")
            .after('<div id="custom-error" class="ui ' +
                    ((flag === 1) ? "green" : "red")
                    + ' pointing label" style="display: block;">'
                    + message
                    + '</div>');
    setTimeout(function () {
        siblings.find("#custom-error").fadeOut();
        $(target).removeClass("loading disabled");
    }, 1500);
}

function reloadPage(interval) {
    setTimeout(function () {
        location.reload();
    }, interval);
}

function loadChain(showGraphTimeout = 10, edit = false) {
    var selector = '#show-object';
    var domContainer = $(selector);
    var id = document.querySelector('[name=object-id]');
    var chain_id = document.querySelector('[name=chain-id]');
    var source_id = document.querySelector('[name=source-id]');
    var source_popup_image_id = document.querySelector('[name=source-popup-image-id]') ? document.querySelector('[name=source-popup-image-id]').value : null;
    if ((domContainer.length === 1) && id) {
        domContainer.children("div").css({opacity: 0, height: '0px'});
        domContainer.addClass("ui form loading when-loading");
        if(edit != true){
            $('.object-detail').addClass("ui form loading when-loading");
        }

        var timezone_offset_minutes = new Date().getTimezoneOffset();
        timezone_offset_minutes = timezone_offset_minutes == 0 ? 0 : -timezone_offset_minutes;
        // var currentTimezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;

        var data = {"id": id.value, "source_popup_image_id": source_popup_image_id,
            "_csrf": $('meta[name=csrf-token]').attr('content'),"timezone":timezone_offset_minutes};
        // ReactDOM.render(null, domContainer[0]);
        $.ajax({
            type: 'post',
            url: site_url + '/chain/object_data',
            dataType: 'json',
            data: data,
            success: function (response) {
                if (typeof response.object !== "undefined") {
                    ReactDOM.render(React.createElement(ChainContainer, response), domContainer[0], function () {
                        var t = (response.object.chains.length > 0 && response.object.chains) ||
                                (response.object.referencePoint.length > 0 && response.object.referencePoint) ||
                                [];
                        var referencePointVar = "";
                        if(edit != true){
                            referencePointVar = response.object.referencePoint;
                        }
                        $().initializeGraph(selector,
                                response.object.referencePoint.length,
                                response.object.actualObjectData,
                                response.object.objectData,
                                referencePointVar,
                                response.object.typeId,
                                response.object.title,
                                response.object.isOwner);
                        if (t.length === 0) {
                            window.history.replaceState(window.location.href,'ObjURL',response.object.viewId);
                            var className = '.section-0';
                            var sb = new SimpleBar($(className).parents("[data-simplebar]")[0]);
                            $(className + " .left_col, " + className + " .right_col").equalHeights();
                            sb.recalculate();
                            dragscroll.reset();
                        }
                        $(".left-section >.content_box [data-simplebar] [class*=section]:not(.inner-line)")
                                .removeClass("remove-after");
                        if (t.length <= 1) {
                            //remove :after as for object with only 1 or 0 chain
                            //there's no need to show link
                            //which connects multiple chains
                            $(".left-section >.content_box [data-simplebar] [class*=section]:not(.inner-line)")
                                    .addClass("remove-after");
                        }
                        t.map((chain, index) => {
                            var className = '.section-' + index;
                            if ($(className).length === 0) {
                                return;
                            }
                            var sb = new SimpleBar($(className).parents("[data-simplebar]")[0]);
                            $(className + " .left_col, " + className + " .right_col").equalHeights();
                            sb.recalculate();
                        });
                        $(".content_box").find(".simplebar-content").addClass("dragscroll");
                        dragscroll.reset();
                        var revertChanges = function () {
                            domContainer.removeClass("ui form loading when-loading");
                            domContainer.addClass("when-loaded");
                            domContainer.children("div").css({opacity: 0, height: 'auto'});
                            domContainer.children("div").css({opacity: 1});
                            if(edit != true){
                                $('.object-detail').removeClass("ui form loading when-loading");
                                $('.object-detail').addClass("when-loaded");
                                $('.object-detail').children("div").css({opacity: 0, height: 'auto'});
                                $('.object-detail').children("div").css({opacity: 1});
                            }else if(edit == true){
                                $('.object-detail').addClass("editObject");
                            }
                        };
                        if (showGraphTimeout > 0) {
                            setTimeout(function () {
                                revertChanges();
                            }, showGraphTimeout);
                        } else {
                            revertChanges();
                        }
                        if (chain_id) {
                            setTimeout(function () {
                                var id = chain_id.value;
                                var sourceId = source_id ? source_id.value : "";
                                var element = document.getElementById(id);
                                
                                scrollReferencePointIntoView(element, id);
                                scrollSourceIntoView(sourceId)
                                $(chain_id).remove();
                            }, 500);
                        }else{
                            setTimeout(function () {
                                scrollSourceIntoView(newSourceViewId);
                            }, 500);
                        }
                    });
                    removeMessageFromObjectForm();
                    // $(".footerClass").hide();
                    loadObject(response.object);
                }
            },
            error: function (jqxhr, status, exception) {
                //console.log(exception);
                //console.log(status);
                //console.log(jqxhr);
            }
        });
}
}

function loadObject(responseData) {
    var { referencePoint } = responseData;
    var tableData = referencePoint.map((r,i) => {
        r.chainId = r.viewId;
        var sourceDropdown = `<div class="singleSource-wrapper"><select class="singleSource ui dropdown" id="singleSource_${r.chainId}" data-chain-id="${r.chainId}"><option value="">Select</option>`;
        
        if(responseData.chains && responseData.chains.length){
            var source = responseData.chains[i];
            if(source && source.sources && source.sources.length){
                source.sources.forEach((s,i) => {
                    sourceDropdown += `<option value="${s.source}">Source ${i+1}</option>`;
                });
            }
        }
        sourceDropdown += '</select></div>';
        r.refPoint = r.title && r.title !== '' ? `${r.title} ${r.value}`:r.value;
        r.selectCheckbox = `<div class="ui checkbox">
                <input type="checkbox" id="checkbox_${r.chainId}" name="object_checkbox" value="${r.chainId}">
                <label></label>
            </div>`;
        r.source = sourceDropdown;
        return r;
    });
    var comparatorFunction = globalFunctions.getComparatorFunction(responseData.typeId);
    if (comparatorFunction !== null) {
        tableData.sort(comparatorFunction);
    }
    // tableData.reverse();
    if ( $.fn.DataTable.isDataTable('#object-table') ) {
        $('#object-table').DataTable().destroy();
        $('#object-table tbody').remove();
    }
    var table = $('#object-table').DataTable({
        data: tableData,
        columns: [
            {
                'className':      'details-control',
                'orderable':      false,
                'data':           null,
                'defaultContent': ''
            },
            { 'data': 'chainId' },
            { 'data': 'refPoint' },
            { 'data': 'source' },
            { 'data': 'selectCheckbox' }
        ],
        searching: false, 
        paging: false, 
        info: false,
        sort: false, 
        order: [[1, 'asc']]
    } );
    // Add event listener for opening and closing details
    $('#object-table tbody').on('click', 'td.details-control', function(){
        var tr = $(this).closest('tr');
        var row = table.row( tr );

        if(row.child.isShown()){
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
        } else {
            // Open this row
            row.child(format(row.data()),'single-url-wrap').show();
            tr.addClass('shown');
        }
    });
    
    
    $("body").on("click", "#copy_tiny_url", function (e) {
        var getChainId = $(this).attr("data-chain-id");
        var tinyUrlContent = $(`#tiny_url_${getChainId} xmp`).text();
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(tinyUrlContent).select();
        document.execCommand("copy");
        $temp.remove();

        // $("#copy_tiny_url").addClass("disabled");
    });
}

function getComparatorFunction(typeId) {
    switch (typeId) {
        case 1: // article
        case 2: // book
            return function (a, b) {
                var n = parseInt(a.value) - parseInt(b.value);
                if (n !== 0) {
                    return n;
                }
                return parseInt(a.section_number) - parseInt(b.section_number);
            };
        case 3: //  event
            return function (a, b) {
                return new Date(a.value) - new Date(b.value);
            };
        case 4: //  movie
            return function (a, b) {
                return new Date("1990-01-01 " + a.value) - new Date("1990-01-01 " + b.value);
            };
        case 8://essay
            return function (a,b) {
                var n = parseInt(a.value) - parseInt(b.value);
                if (n !== 0) {
                    return n;
                }
                return parseInt(a.section_number) - parseInt(b.section_number);
            }
        case 9://blog
            return function (a,b) {
                if(a.refType == 2 && b.refType == 2){
                    var n = parseInt(a.value) - parseInt(b.value);
                    if (n !== 0) {
                        return n;
                    }
                    return parseInt(a.section_number) - parseInt(b.section_number);
                }
                else{
                    return new Date(a.value) - new Date(b.value);
                }                
            }
        case 10://social media
            return function (a,b) {
                if(a.refType == 2 && b.refType == 2){
                    var n = parseInt(a.value) - parseInt(b.value);
                    if (n !== 0) {
                        return n;
                    }
                    return parseInt(a.section_number) - parseInt(b.section_number);
                }
                else{
                    return new Date(a.value) - new Date(b.value);
                }                
            }
        case 11://article-web
            return function (a,b) {
                var n = parseInt(a.value) - parseInt(b.value);
                if (n !== 0) {
                    return n;
                }
                return parseInt(a.section_number) - parseInt(b.section_number);
            }
        case 12://education
            return function (a,b) {
                if(a.refType == 2 && b.refType == 2){
                    var n = parseInt(a.value) - parseInt(b.value);
                    if (n !== 0) {
                        return n;
                    }
                    return parseInt(a.section_number) - parseInt(b.section_number);
                }
                else{
                    return new Date(a.value) - new Date(b.value);
                }                
            }
        default:
            //  personal opinion
            return null;
    }
}

globalFunctions.getComparatorFunction = (typeId) => getComparatorFunction(typeId);

globalFunctions.loadChain = () => loadChain();

loadChain(0);


/* sourcelink content */
function getSourceContent(chainNumber, source = "") {
    return `<sourcelink chain="${chainNumber}" source="${source}">YOUR_TEXT_HERE</sourcelink>`;
}

/* Formatting function for row details - modify as you need */
function format ( d ) {
    var chainNumber = d.chainId.split("-").pop();
    var value = $(`#singleSource_${d.chainId} :selected`).val();
    var source = value ? value : "";
    var content = getSourceContent(chainNumber,source);
    return `<div class="single_url_block">
        <div class="btn-custom-wrap">
        <button id="copy_tiny_url" class="ui button" data-chain-id="${d.chainId}"><i class="copy outline icon"></i>Copy</button>
        </div>
        <div id="tiny_url_${d.chainId}"><xmp>${content}</xmp></div>
    </div>`;
}

$("body").on("click", "#copy_selected_tiny_url", function (e) {
    var selectedContent = "";
    $('[name="object_checkbox"]:checked').each(function() {
        var chainNumber = this.value.split("-").pop();
        var value = $(`#singleSource_${this.value} :selected`).val();
        var source = value ? value : "";
        selectedContent += `
        ${getSourceContent(chainNumber,source)}`;
     });
     var $temp = $("<textarea>");
     $("body").append($temp);
     $temp.val(selectedContent).select();
     document.execCommand("copy");
     $temp.remove();
});

$("body").on("change", ".singleSource", function (e) {
    var getChainId = $(this).attr("data-chain-id");
    var chainNumber = getChainId.split("-").pop();
    var source = $(this).val();
    var content = getSourceContent(chainNumber,source);
    $(`#tiny_url_${getChainId} xmp`).text(content);
});

$("body").on("click", "#copy_sample_code", function (e) {
     var sampleCode = $("#sample_code_content").text();
     var $temp = $("<textarea>");
     $("body").append($temp);
     $temp.val(sampleCode).select();
     document.execCommand("copy");
     $temp.remove();
});

$('#object_select_all:checkbox').change(function () {
    if($(this).prop("checked")){
        $('[name="object_checkbox"]').prop("checked", true);
    }
    else{
        $('[name="object_checkbox"]'). prop("checked", false);
    } 
});


/* Format code snippet and add line */
(function() {
    var pre = document.getElementsByTagName('pre'),
        pl = pre.length;
    for (var i = 0; i < pl; i++) {
        pre[i].innerHTML = '<span class="line-number"></span>' + pre[i].innerHTML + '<span class="cl"></span>';
        var num = pre[i].innerHTML.split(/\n/).length;
        for (var j = 0; j < num; j++) {
            var line_num = pre[i].getElementsByTagName('span')[0];
            line_num.innerHTML += '<span>' + (j + 1) + '.</span>';
        }
    }
})();

/* tabs switching for object and embeded */
$(document).ready(function () {
    $('.tab-switcher').click(function(){
            $("#vertical-navigation-arrows").hide();
            // $(".footerClass").show();
            var tabClicked = $(this).data("tab-index");
            $('.tab-switcher').removeClass("active");
            $(".tab-container").hide();
            $(".tab-container").each(function () {
                if($(this).data("tab-index") == tabClicked) {
                    $(`.tab-switcher[data-tab-index="${tabClicked}"]`).addClass("active");
                    $(this).show();
                    if(tabClicked === 1){
                        $("#vertical-navigation-arrows").show();
                        // $(".footerClass").hide();
                    }
                }
            });
    });

    
/* replace generated key in profile */
    $('#key_gen_btn').click(function(){
        $.ajax({
            type: 'get',
            url: site_url + '/user/default/get-api-key',
            success: function (response) {
                console.log(response)
                $("#accountform-rest_key").val(response);
            }
        });
    });
    $('#copy_gen_btn').click(function(){
        var keyInput = $("#accountform-rest_key");
        keyInput.select();
        document.execCommand("copy");
    });

});


// WEBPACK FOOTER //
// ./frontend/web/js/app.js